import { takeEvery, put, all, call } from "redux-saga/effects";

import { LoginSuccessActionCreator, LogoutActionCreator } from "../../auth/state/actions";

import { ClearIdentityActionCreator, FetchIdentity } from "./actions";

function* identification() {
  yield takeEvery(LoginSuccessActionCreator, function* () {
    yield put(FetchIdentity() as any);
  });
  yield takeEvery(LogoutActionCreator, function* () {
    yield put(ClearIdentityActionCreator() as any);
  });
}

export function* profileSagas() {
  yield all([call(identification)]);
}
